export const COMPANY = {
  name: "Daksh Detective and Security Services Private Limited",
  shortName: "Daksh",
  tagline: "Reliable Manpower. Professional Services. Trusted Since 2003.",
  phone: "+91 9878227336",
  phoneHref: "tel:+919878227336",
  whatsapp: "https://wa.me/919464905072?text=Hello%20Daksh%2C%20I%20would%20like%20to%20discuss%20a%20manpower%20requirement.",
  whatsappDisplay: "+91 9464905072",
  email: "ddsservicespvtltd@yahoo.in",
  emailHref: "mailto:ddsservicespvtltd@yahoo.in",
  address: "SCO 10, 11, 12, Sector 17-B, Chandigarh, India",
  md: "Arjun Singh Chauhan",
  incorporated: "07 February 2003",
};

export const LOGO = "/assets/logo.png";

export const IMAGES = {
  hero: "/assets/team-guards.png",
  security: "/assets/team-tdi.png",
  facility: "https://images.unsplash.com/photo-1748261500463-d15e624baf8f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHxfHxmYWNpbGl0eSUyMG1hbmFnZW1lbnR8ZW58MHx8fHwxNzkwMTQyMzEwfDA&ixlib=rb-4.1.0&q=85",
  sanitation: "https://images.pexels.com/photos/6197108/pexels-photo-6197108.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  warehousing: "https://images.unsplash.com/photo-1781559818983-4180d744416a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3MlMjB3YXJlaG91c2V8ZW58MHx8fHwxNzkwMTQyMzEwfDA&ixlib=rb-4.1.0&q=85",
  manpower: "https://images.pexels.com/photos/31112251/pexels-photo-31112251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  industrial: "https://images.pexels.com/photos/4484073/pexels-photo-4484073.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    slug: "manpower-outsourcing",
    path: "/manpower",
    title: "Manpower Outsourcing",
    short: "Flexible workforce solutions for organizations requiring outsourced personnel for daily operations, projects and specialized requirements.",
    icon: "Users",
    image: IMAGES.manpower,
    intro: [
      "Daksh provides dependable outsourced manpower for organizations that need reliable personnel without the administrative burden of direct recruitment, payroll management and statutory compliance.",
      "From daily operations to project-based requirements, we deploy trained and supervised personnel matched to your operational environment — corporate offices, institutions, industrial units and commercial establishments.",
    ],
    offerings: [
      { title: "Office Support Staff", desc: "Peons, office boys, reception support, pantry staff and administrative helpers for corporate offices and institutions." },
      { title: "Skilled & Semi-Skilled Workforce", desc: "Technicians, electricians, plumbers, drivers, machine operators and trade-specific personnel." },
      { title: "Unskilled Workforce", desc: "Helpers, loaders, general duty staff and support manpower for day-to-day operations." },
      { title: "Supervisory Personnel", desc: "Experienced supervisors to manage deployed teams, attendance, discipline and reporting at your site." },
      { title: "Project-Based Deployment", desc: "Short-term and long-term workforce arrangements structured around your project timelines." },
      { title: "Payroll & Compliance Management", desc: "Managed attendance, wages and statutory compliance for all deployed personnel." },
    ],
    categories: ["Office Boys", "Peons", "Helpers", "Drivers", "Technicians", "Electricians", "Plumbers", "Data Entry Operators", "Reception Support", "Supervisors", "Loaders", "Pantry Staff"],
  },
  {
    slug: "security-services",
    path: "/security-services",
    title: "Security Services",
    short: "Security personnel and supervisory manpower for commercial, institutional, industrial, residential and event requirements.",
    icon: "ShieldCheck",
    image: IMAGES.security,
    intro: [
      "Daksh has provided security manpower since 2003. We deploy trained security guards and supervisory personnel for commercial establishments, institutions, industrial facilities and residential societies.",
      "Every deployment is backed by site supervision, attendance monitoring and a clear escalation structure so that your premises remain professionally managed around the clock.",
    ],
    offerings: [
      { title: "Security Guards", desc: "Uniformed guards for gates, receptions, perimeters and internal security duties across shifts." },
      { title: "Security Supervisors", desc: "Site-level supervision, shift management, duty rosters and incident reporting." },
      { title: "Access Control", desc: "Entry-exit management, visitor registers, material gate passes and movement control." },
      { title: "Industrial Security", desc: "Security manpower for factories, plants and industrial establishments with shift-based deployment." },
      { title: "Residential Security", desc: "Guards and supervisors for residential societies, townships and housing complexes." },
      { title: "Patrolling & Monitoring", desc: "Scheduled patrolling, CCTV monitoring support and night security arrangements." },
    ],
    categories: ["Security Guards", "Security Supervisors", "Gate Management", "Reception Security", "Night Security", "Patrolling Staff", "CCTV Monitoring Support", "Traffic & Parking Marshals"],
  },
  {
    slug: "facility-management",
    path: "/facility-management",
    title: "Facility Management",
    short: "Operational manpower and support services to help organizations maintain efficient and well-managed facilities.",
    icon: "Building2",
    image: IMAGES.facility,
    intro: [
      "Well-run facilities depend on dependable people. Daksh supplies the operational manpower and supervisory support that keeps offices, institutions and commercial facilities running smoothly every day.",
      "We structure facility teams around your premises — combining housekeeping, technical support, front-office and utility staff under managed supervision.",
    ],
    offerings: [
      { title: "Housekeeping Staff", desc: "Trained housekeeping personnel for offices, institutions, hospitals and commercial buildings." },
      { title: "Technical Support Staff", desc: "Electricians, plumbers, carpenters and utility technicians for facility upkeep." },
      { title: "Front Office & Pantry", desc: "Reception support, pantry staff and guest-area management personnel." },
      { title: "Utility & Maintenance", desc: "Lift operators, gardeners, STP/pump operators and general maintenance manpower." },
      { title: "Facility Supervisors", desc: "On-site supervisors to coordinate teams, quality checks and daily reporting." },
      { title: "Integrated Support", desc: "Combined facility teams structured around your premises and operating hours." },
    ],
    categories: ["Housekeeping Staff", "Electricians", "Plumbers", "Lift Operators", "Gardeners", "Pantry Staff", "Facility Supervisors", "Carpenters", "Pump Operators"],
  },
  {
    slug: "sanitation-cleaning",
    path: "/sanitation",
    title: "Sanitation & Cleaning",
    short: "Manpower support for cleaning, sanitation, hygiene and related facility requirements.",
    icon: "Sparkles",
    image: IMAGES.sanitation,
    intro: [
      "Clean, hygienic premises are fundamental to every workplace, institution and public facility. Daksh provides trained sanitation and cleaning manpower with the supervision needed to maintain consistent standards.",
      "From daily cleaning schedules to deep-cleaning assignments, our personnel are deployed with defined checklists and supervisory oversight.",
    ],
    offerings: [
      { title: "Daily Cleaning Manpower", desc: "Sweepers, cleaners and housekeeping staff for routine daily sanitation schedules." },
      { title: "Deep Cleaning Support", desc: "Manpower for periodic deep cleaning of premises, washrooms, facades and common areas." },
      { title: "Washroom Hygiene", desc: "Dedicated attendants and cleaning schedules for washroom hygiene management." },
      { title: "Waste Management Support", desc: "Personnel for waste segregation, collection support and disposal coordination." },
      { title: "Institutional Sanitation", desc: "Sanitation teams for hospitals, schools, government buildings and public facilities." },
      { title: "Supervised Quality Checks", desc: "Supervisory inspection routines to maintain consistent hygiene standards." },
    ],
    categories: ["Sweepers", "Cleaners", "Housekeeping Staff", "Washroom Attendants", "Waste Management Staff", "Deep Cleaning Teams", "Sanitation Supervisors"],
  },
  {
    slug: "warehousing-management",
    path: "/warehousing",
    title: "Warehousing Management",
    short: "Workforce solutions for warehouse operations, material handling, support functions and day-to-day warehouse activities.",
    icon: "Warehouse",
    image: IMAGES.warehousing,
    intro: [
      "Warehouse operations run on reliable manpower. Daksh provides the workforce that keeps goods moving — from loading docks to inventory floors — with supervision and shift-based deployment.",
      "We support warehouses, distribution centres and industrial storage facilities with personnel trained for material handling and warehouse discipline.",
    ],
    offerings: [
      { title: "Loading & Unloading", desc: "Loaders and unloading crews for inbound and outbound material movement." },
      { title: "Pickers & Packers", desc: "Picking, packing and dispatch-support personnel for order fulfilment operations." },
      { title: "Inventory Support", desc: "Stock counting support, shelf arrangement and inventory handling manpower." },
      { title: "Forklift & Equipment Operators", desc: "Operators for forklifts and material handling equipment, as per requirement." },
      { title: "Warehouse Supervisors", desc: "Shift supervisors for attendance, task allocation and operational reporting." },
      { title: "Housekeeping for Warehouses", desc: "Cleaning and upkeep manpower for large storage and logistics facilities." },
    ],
    categories: ["Loaders", "Pickers", "Packers", "Forklift Operators", "Inventory Assistants", "Warehouse Supervisors", "Dispatch Support", "Warehouse Housekeeping"],
  },
  {
    slug: "event-security",
    path: "/event-security",
    title: "Event Security",
    short: "Security personnel and supervisors for events, venues, gatherings and special assignments.",
    icon: "TicketCheck",
    image: IMAGES.industrial,
    intro: [
      "Events demand security manpower that is disciplined, presentable and well-coordinated. Daksh deploys event security personnel and supervisors for gatherings of every scale.",
      "From entry management to crowd movement and VIP areas, our teams work under an event-specific duty plan agreed with your organizers in advance.",
    ],
    offerings: [
      { title: "Event Security Guards", desc: "Uniformed personnel for entry gates, stage areas, back-of-house and perimeters." },
      { title: "Crowd Management", desc: "Queue management, crowd flow control and audience-area deployment." },
      { title: "Access & Pass Control", desc: "Ticket/pass checking, guest list management and restricted-zone control." },
      { title: "VIP Movement Support", desc: "Dedicated personnel for VIP areas, green rooms and controlled movement routes." },
      { title: "Parking & Traffic Marshals", desc: "Parking management and vehicle movement control for event venues." },
      { title: "Event Supervisors", desc: "On-ground supervisors coordinating with organizers through the event." },
    ],
    categories: ["Event Guards", "Crowd Control Staff", "Gate & Pass Checkers", "VIP Security", "Parking Marshals", "Event Supervisors", "Bouncers", "Ushers"],
  },
];

export const INDUSTRIES = [
  { name: "Government Departments", icon: "Landmark" },
  { name: "Government Institutions & PSUs", icon: "Building" },
  { name: "Hospitals & Healthcare", icon: "HeartPulse" },
  { name: "Schools & Universities", icon: "GraduationCap" },
  { name: "Corporate Offices", icon: "Briefcase" },
  { name: "Hotels & Hospitality", icon: "Hotel" },
  { name: "Shopping Malls & Retail", icon: "ShoppingBag" },
  { name: "Factories & Industrial Units", icon: "Factory" },
  { name: "Warehouses & Logistics", icon: "Warehouse" },
  { name: "Construction Companies", icon: "HardHat" },
  { name: "Residential Societies", icon: "Home" },
  { name: "Event Organizers", icon: "CalendarDays" },
  { name: "Retail Businesses", icon: "Store" },
  { name: "Industrial Establishments", icon: "Cog" },
];

export const OPEN_ROLES = [
  { title: "Security Guard", location: "Chandigarh / Mohali / Panchkula", type: "Full-time" },
  { title: "Security Supervisor", location: "Chandigarh Region", type: "Full-time" },
  { title: "Housekeeping / Sanitation Staff", location: "Chandigarh Region", type: "Full-time" },
  { title: "Facility Management Staff", location: "Chandigarh Region", type: "Full-time" },
  { title: "Warehouse Associate", location: "Chandigarh / Baddi", type: "Full-time" },
  { title: "Office Support Staff", location: "Chandigarh", type: "Full-time" },
];

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Manpower", path: "/manpower" },
  { label: "Industries", path: "/industries" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" },
];

export const FEATURED_CLIENTS = [
  { name: "Mahatma Gandhi Institute", place: "Chandigarh" },
  { name: "Ordnance Factory", place: "Chandigarh" },
  { name: "Sports Council", place: "Chandigarh" },
];

export const CLIENTS = [
  { name: "TDI Mall", place: "Chandigarh" },
  { name: "Income Tax Department", place: "Chandigarh, Panchkula, Mohali, Yamunanagar, Ambala & Nangal" },
  { name: "Govt. Polytechnic for Women", place: "Morni Hills, Panchkula" },
  { name: "Directorate of Disinvestment, Punjab (Govt.)", place: "Sector-17 E, Chandigarh" },
  { name: "Directorate of Institutional Finance & Banking (PB)", place: "Sector-17 E, Chandigarh" },
  { name: "Director Industrial & Vocational Training", place: "30 Bays Building, Sector-17, Chandigarh" },
  { name: "H.R. Civil Secretariat", place: "Sector-1, Chandigarh" },
  { name: "NITTTR", place: "Sector-26, Chandigarh" },
  { name: "Govt. Museum & Art Gallery", place: "Sector-10, Chandigarh" },
  { name: "Beant Singh Memorial", place: "Sector-42, Chandigarh" },
  { name: "Executive Engineer C.P. Division No. 4", place: "Chandigarh" },
  { name: "Executive Engineer C.P. Division No. 1", place: "Chandigarh" },
  { name: "Executive Engineer C.P. Division No. 1 (Sector-42 Lake)", place: "Chandigarh" },
  { name: "Yadvindra Public School", place: "Sector-51, Mohali" },
  { name: "D.G.S.E.", place: "Shikshak Sadan, Sector-5, Panchkula" },
  { name: "H.R. State Technical Education Society", place: "Bays No. 7-12, Sector-4, Panchkula" },
  { name: "H.R. State Board of Technical Education", place: "Bays No. 7-12, Sector-4, Panchkula" },
  { name: "Director Technical Education", place: "Bays No. 7-12, Sector-4, Panchkula" },
  { name: "Income Tax Colony", place: "Sector-20, Panchkula" },
  { name: "Govt. ITI", place: "Raipur Rani" },
  { name: "Govt. ITI", place: "Sector-14, Panchkula" },
];
